import appConfig from 'app-config';
import { getProxiedServiceUrl } from '@xengage/gw-portals-url-js';
import { JsonRPCService } from '@xengage/gw-portals-transport-js';

const capabilityPrefix = appConfig.portalCode === 'GPA' ? 'gateway' : '';

export default {
    inferOneTimePaymentForm: (policyNumbers, formDTO, instrumentId, totalPaymentAmount, additionalHeaders = {}) => {
        return JsonRPCService.send(getProxiedServiceUrl(`${capabilityPrefix}form`), 'inferOneTimePaymentForm', [policyNumbers, formDTO, instrumentId, totalPaymentAmount], additionalHeaders);
    },
    updateForms: (quoteID, formDTOs, additionalHeaders = {})=> {
        return JsonRPCService.send(getProxiedServiceUrl(`${capabilityPrefix}form`), 'updateForms', [quoteID, formDTOs], additionalHeaders);
    },
    getNewlyAddedForms: (quoteID, additionalHeaders = {})=> {
        return JsonRPCService.send(getProxiedServiceUrl(`${capabilityPrefix}form`), 'getNewlyAddedForms', [quoteID], additionalHeaders);
    }
};